export const sliderArrowLeft = () => {
  return (
    <svg
      width='13'
      height='20'
      viewBox='0 0 13 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M11.9886 19.7417C12.6112 19.4315 12.8959 18.7664 12.6951 18.0913C12.6223 17.8465 12.5041 17.6704 12.2454 17.4212C12.0523 17.2353 10.0342 15.4927 7.76061 13.5486C5.48699 11.6047 3.62842 9.9937 3.63034 9.96873C3.63227 9.94377 5.47265 8.35446 7.72004 6.43698C12.8783 2.03584 12.6305 2.26236 12.758 1.8335C13.1153 0.63175 11.8668 -0.41853 10.7779 0.167703C10.3866 0.37841 0.492181 8.86938 0.265005 9.18952C-0.155214 9.78147 -0.0700141 10.488 0.486869 11.0298C0.661583 11.1998 3.02053 13.2336 5.72891 15.5494C9.42316 18.7081 10.7189 19.7795 10.9163 19.8386C11.3197 19.9596 11.6029 19.9339 11.9886 19.7417Z'
        fill='black'
      />
    </svg>
  );
};
